import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/withRouter';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import CustomerCartBanner from '../Components/CustomerCartBanner';
import { changeLayoutMode, changeFontSize } from "../slices/thunks";
import { useSelector, useDispatch } from "react-redux";


const Layout = (props) => {
    const dispatch = useDispatch();
    const layoutModeType = useSelector(state => state?.layout?.layoutModeType);
    const currentFontSize = useSelector(state => state?.layout?.fontSize);

    //call dark/light mode
    const onChangeLayoutMode = (value) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };
    const onChangeFontSize = (value) => {
        if (changeFontSize) {
            dispatch(changeFontSize(value));
        }
    };

    useEffect(() => {
        onChangeLayoutMode(layoutModeType);
        onChangeFontSize(currentFontSize);
    }, [])

    const [headerClass, setHeaderClass] = useState("");

    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    currentFontSize={currentFontSize}
                    onChangeFontSize={onChangeFontSize}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar />
                <div className="main-content">
                    <CustomerCartBanner />
                    {props.children}
                    <Footer />
                </div>
            </div>
        </React.Fragment>

    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);